import fetchRetry from '~~/common/js/universal/fetch-retry';
import treeDataMock from '../mocks/treedata';

/* eslint-disable import/prefer-default-export */
export const fetchTreeData = async (apiUrl, mocked = false) => {
  if (mocked) {
    return treeDataMock;
  }
  const response = await fetchRetry(`${apiUrl}/v1/trees/count`);
  return response.json();
};
